import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const sushisupplyCustomerGroup = 'sushisupply';
export const customerGroup = sushisupplyCustomerGroup;

const supportEmail = {
	sushisupply: 'sushisupply@smoothr.de'
};
const firebaseConfig = {
	sushisupply: {
		apiKey: 'AIzaSyAcEE0JJJM0MQnUaBkMcuVynB9KPF7cK1g',
		authDomain: 'sushisupply-8e8d9.firebaseapp.com',
		projectId: 'sushisupply-8e8d9',
		storageBucket: 'sushisupply-8e8d9.appspot.com',
		messagingSenderId: '77903306877',
		appId: '1:77903306877:web:77179fa442d4e705865114',
		measurementId: 'G-P8VYHN81E3'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAoYayCReMcARv8EJgIUQ7sjcDCxcbFeWE',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment
};
